import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { ScheduleIntervalAction } from './scheduleInterval.action';
import { scheduleIntervalInitialState } from './scheduleInterval.constant';

export const scheduleIntervalReducer = reducerWithInitialState(scheduleIntervalInitialState)
  .case(ScheduleIntervalAction.load.started, (state, payload) => {
    const { loading } = state;

    return {
      ...state,
      loading: {
        ...loading,
        [payload.scheduleId]: true,
      },
    };
  })
  .case(ScheduleIntervalAction.load.done, (state, payload) => {
    const { data, loading } = state;
    const { params, result } = payload;

    return {
      ...state,
      data: {
        ...data,
        [params.scheduleId]: result,
      },
      loading: Object.fromEntries(
        Object.entries(loading).filter(([key]) => key !== String(params.scheduleId)),
      ),
    };
  })
  .case(ScheduleIntervalAction.load.failed, (state, payload) => {
    const { loading } = state;
    const { params } = payload;

    return {
      ...state,
      loading: Object.fromEntries(
        Object.entries(loading).filter(([key]) => key !== String(params.scheduleId)),
      ),
    };
  })
  .case(ScheduleIntervalAction.remove.done, (state, payload) => {
    const { data } = state;
    const { params, result } = payload;

    if (result) {
      return {
        ...state,
        data: {
          ...data,
          [params.scheduleId]: result,
        },
      };
    }

    return state;
  })
  .case(ScheduleIntervalAction.removeSchedule, (state, payload) => {
    const { data } = state;
    const { scheduleId } = payload;

    delete data[scheduleId];

    return {
      ...state,
      data: {
        ...data,
      },
    };
  })
  .case(ScheduleIntervalAction.destroy, () => ({
    ...scheduleIntervalInitialState,
  }));
